import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import Header from './header'
import Headernew from './headernew'
import Footer from './footer'
import Promotion from './promotion'
import ProductLogoShowcase from './product-logo-showcase'
import './layout.css'

// import '../fonts/fonts.css'
import '../styles/index.scss'
import '../styles/output.css'
import '../styles/custom.scss'
// import '../styles/blog.scss'

import { adRefCity } from '../helpers/adRefTracking'

const Layout = ({
  children,
  pageProps,
  footerLogoShowcase,
  isHomePage,
  customSchema,
}) => {
  //capture initial landing URL & date
  let isBetaEnabled =
    typeof window !== 'undefined' &&
    window.localStorage &&
    window.localStorage.getItem('BETA_FEATURES')

  if (
    typeof window !== 'undefined' &&
    window.localStorage &&
    !window.localStorage.getItem('landingURL')
  ) {
    window.localStorage.setItem('landingURL', pageProps.location.href)
    window.localStorage.setItem('landingDate', new Date())
  }
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
              description
              companyInfo {
                phone
                email
                addressLine1
                addressLine2
                city
                state
                zip
                license
              }
            }
          }
          allContentfulNavigation(filter: { campaign: { ne: null } }) {
            edges {
              node {
                id
                name
                menuItems {
                  id
                  name
                  title
                  url
                  openInNewWindow
                  submenu {
                    id
                    name
                    menuItems {
                      id
                      name
                      title
                      url
                      openInNewWindow
                      subMenuSection {
                        id
                        name
                        title
                        url
                        menuItems {
                          id
                          name
                          title
                          url
                          openInNewWindow
                        }
                      }
                    }
                  }
                  subMenuSection {
                    id
                    name
                    title
                    url
                    menuItems {
                      id
                      name
                      title
                      url
                      openInNewWindow
                    }
                  }
                }
                campaign
              }
            }
          }
        }
      `}
      render={(data) => (
        <>
          <Header
            siteTitle={data.site.siteMetadata.title}
            siteDescription={adRefCity(data.site.siteMetadata.description)}
            companyInfo={data.site.siteMetadata.companyInfo}
            mainNavigation={
              data.allContentfulNavigation.edges.filter(
                ({ node: { campaign } }) =>
                  campaign.length > 0 ? campaign[0] === 'default' : false
              )[0].node.menuItems
            }
            menus={data.allContentfulNavigation.edges}
            pageProps={pageProps}
          />

          <div className="layout-container">{children}</div>
          <ProductLogoShowcase footerLogoShowcase={footerLogoShowcase} />
          <Footer isHomePage={isHomePage} />
          <Promotion />
          {!customSchema && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: `
              {
                "@id": "https://www.houseidea.com/#HomeAndConstructionBusiness",
                "@context": "https://www.schema.org",
                "@type": "HomeAndConstructionBusiness",
                "name": "HouseIdea",
                "url": "https://www.houseidea.com/",
                "logo": "https://images.ctfassets.net/s4ybdu2ld1ox/6xK0lKRRwXbLkogCLJSCIs/91cdee98f7181904fa12388663171239/houseidea-thumb2.jpg",
                "image": "https://images.ctfassets.net/s4ybdu2ld1ox/6xK0lKRRwXbLkogCLJSCIs/91cdee98f7181904fa12388663171239/houseidea-thumb2.jpg",
                "description": "HouseIdea is a locally owned and operated full service design build contractor in Sacramento, CA specializing in whole house remodeling and building custom homes.",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "3543 1st Ave #3",
                    "addressLocality": "Sacramento",
                    "addressRegion": "CA",
                    "postalCode": "95817",
                    "addressCountry": "US"
                },
  
                "openingHours": "Mo, Tu, We, Th, Fr 08:00-18:00",
                "contactPoint": {
                    "@type": "ContactPoint",
                    "contactType": "sales",
                    "telephone": "+1 916-675-0267"
                }
            }`,
              }}
            />
          )}
        </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

//classes for tailwind to include when doing purge
// pr-2
